import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IEconomicActivityStatus {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  economicallyActiveTotal?: number | null;
  inEmployment?: number | null;
  employeePartTime?: number | null;
  employeeFullTime?: number | null;
  selfEmployed?: number | null;
  unemployed?: number | null;
  economicallyInactiveTotal?: number | null;
  retired?: number | null;
  student?: number | null;
  lookingAfterHomeFamily?: number | null;
  longTermSickDisabled?: number | null;
  other?: number | null;
}

export const defaultValue: Readonly<IEconomicActivityStatus> = {};
